import styled from "styled-components";
// local imports
import { Div } from "ui";

export const ChartContainer = styled(Div)`
  width: 100%;
  z-index: -1;
  position: absolute;
  bottom: calc(-70vh);
`;
